import React, { useState, useEffect } from 'react';
import StickyNavbar from './StickyNavbar';
import ContactModal from './ContactModal';
import HeroSection from './HeroSection';
import ProductLineSection from './ProductLineSection';
import InnovativePropertiesBento from './InnovativePropertiesBento';
import DirectorSection from './DirectorSection';
import ProductionSection from './ProductionSection';
import ProductShowcaseSticky from './ProductShowcaseSticky';
import CostOfCareMatrix from './CostOfCareMatrix';
import FdaTrustBar from './FdaTrustBar';
import PublicationsSection from './PublicationsSection';
import FinalCTA from './FinalCTA';
import Footer from '../FlexiOssLanding/Footer';
import PhilHealthCallout from '../PhilHealthCallout';
import FloatingAIRobot from './FloatingAIRobot';

const FlexiOssCinematic = () => {
  const [contactOpen, setContactOpen] = useState(false);
  const [contactIntent, setContactIntent] = useState('samples');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const c = params.get('contact');
    if (c) {
      setContactIntent(['pricing', 'samples'].includes(c) ? c : 'samples');
      setContactOpen(true);
    }
  }, []);

  const openContact = (intent = 'samples') => {
    setContactIntent(typeof intent === 'string' ? intent : 'samples');
    setContactOpen(true);
  };
  const closeContact = () => setContactOpen(false);

  return (
    <div className="relative bg-slate-950" data-testid="main-app-container">
      <StickyNavbar onOpenContact={openContact} />
      <ContactModal isOpen={contactOpen} onClose={closeContact} initialIntent={contactIntent} />

      <main>
        <HeroSection onContactClick={openContact} />
        <FdaTrustBar />
        <CostOfCareMatrix />
        <ProductLineSection />
        <InnovativePropertiesBento />
        <DirectorSection />
        <ProductionSection />
        <ProductShowcaseSticky />
        <div id="research"><PublicationsSection /></div>
        <FinalCTA onContactClick={openContact} />
      </main>

      <section className="bg-slate-950 px-6 lg:px-8 pt-2 pb-16"><div className="mx-auto max-w-5xl"><PhilHealthCallout /></div></section>
      <Footer />
      <FloatingAIRobot />
    </div>
  );
};

export default FlexiOssCinematic;
